// Lokalni status poruke (samo na klijentu; server ne salje ovo polje).
export const MESSAGE_STATUS = {
  PENDING: 'pending',
  SENT: 'sent',
  FAILED: 'failed',
};

export const PHARMACY_SIDE = 'pharmacy';
export const PATIENT_SIDE = 'patient';

const toTime = (value) => {
  const time = new Date(value).getTime();
  return Number.isNaN(time) ? 0 : time;
};

const byCreatedAtAsc = (a, b) => {
  const diff = toTime(a.createdAt) - toTime(b.createdAt);
  if (diff !== 0) return diff;
  // Stabilan tie-break kada dve poruke dele isti timestamp.
  return String(a.id || a.clientMessageId || '').localeCompare(
    String(b.id || b.clientMessageId || '')
  );
};

// Poruka pristigla sa servera je uvek trajno sacuvana => status SENT.
export const normalizeServerMessage = (message) => ({
  ...message,
  status: MESSAGE_STATUS.SENT,
});

// Optimisticki "baloncic" pre nego sto server potvrdi (ack).
export const createOptimisticMessage = ({
  clientMessageId,
  conversationId,
  content,
  senderId,
  senderName,
}) => ({
  id: null,
  conversationId,
  senderId,
  senderSide: PHARMACY_SIDE,
  senderName,
  content,
  clientMessageId,
  createdAt: new Date().toISOString(),
  status: MESSAGE_STATUS.PENDING,
});

// Upsert + dedupe po `id` I po `clientMessageId`, uz hronolosko sortiranje.
// Dolazna poruka menja postojecu ako se poklopi bilo koji od dva kljuca -
// tako se optimisticki baloncic izmiri sa trajnom porukom bez duplikata.
export const upsertMessages = (existing, incoming) => {
  const list = [...existing];
  const indexById = new Map();
  const indexByClientId = new Map();

  list.forEach((message, index) => {
    if (message.id != null) indexById.set(message.id, index);
    if (message.clientMessageId) {
      indexByClientId.set(message.clientMessageId, index);
    }
  });

  const items = Array.isArray(incoming) ? incoming : [incoming];

  items.forEach((message) => {
    if (!message) return;

    let index = -1;
    if (message.id != null && indexById.has(message.id)) {
      index = indexById.get(message.id);
    } else if (
      message.clientMessageId &&
      indexByClientId.has(message.clientMessageId)
    ) {
      index = indexByClientId.get(message.clientMessageId);
    }

    if (index >= 0) {
      list[index] = { ...list[index], ...message };
    } else {
      const nextIndex = list.push(message) - 1;
      if (message.id != null) indexById.set(message.id, nextIndex);
      if (message.clientMessageId) {
        indexByClientId.set(message.clientMessageId, nextIndex);
      }
    }
  });

  list.sort(byCreatedAtAsc);
  return list;
};

// Ime clana koji salje (za optimisticki balon), iz auth korisnika.
export const getStaffDisplayName = (user) =>
  `${user?.firstName || ''} ${user?.lastName || ''}`.trim() || 'Apoteka';
